"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        padding: 14,
        backgroundColor: theme.white1,
        border: `1px solid ${theme.grey6}`,
        borderRadius: 4
    }
});
//# sourceMappingURL=tile.style.js.map